export default "__VITE_ASSET__Bh2VtK$T__"